import { FC } from 'react';

import { Box, Stack, StackProps, Text, Title } from '@mantine/core';

import { LogoIcon } from '@/assets/icons';

interface LoadingPageProps extends StackProps {
  title?: string;
  message?: string;
  withLogo?: boolean;
}

const LoadingPage: FC<LoadingPageProps> = ({ withLogo = true, message, title, ...stackProps }) => {
  return (
    <Stack w={'100%'} justify={'center'} align={'center'} mih={'90vh'} gap={'md'} {...stackProps}>
      {withLogo && (
        <Box mb={2}>
          <LogoIcon width={160} height={160} />
        </Box>
      )}
      {title && (
        <Title c={'gray.8'} size={'h4'} fw={'600'} lh={0}>
          {title}
        </Title>
      )}
      {message && <Text c={'gray.6'}>{message}</Text>}
    </Stack>
  );
};

export default LoadingPage;
